import { MultiFormContainer } from 'components/multi-form/MultiFormContainer';
import { LoadingModal } from 'components/response/LoadingModal';
import { LoanPersonalInfoSingleForm } from 'components/single-form-view/loan/LoanPersonalInfoSingleForm';
import { LoanSimpleVehicleInfoForm } from 'components/single-form-view/loan/LoanSimpleVehicleInfoForm';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import { LOAN_ACTIONS } from 'constants/LoanActions';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR } from 'constants/ResponseType';
import { FormContext } from 'context/FormContext';
import { useLoanFormContainerControl } from 'hooks/useLoanFormContainerControl';
import { useLogin } from 'hooks/useLogin';
import { ActionButtonConfig } from 'models/ActionButtonConfig';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const config = [
	{
		buttonBackName: 'Volver',
		buttonNextName: 'Comenzar',
		backAction: LOAN_ACTIONS.BACK_TO_HOME,
		nextAction: LOAN_ACTIONS.SAVE_FORM_AND_UPDATE_WITH_KNOCKOUT,
	},
	{
		buttonBackName: 'Volver',
		buttonNextName: 'Continuar',
		backAction: LOAN_ACTIONS.RESET_ID_STATUS_AND_BACK_STEP,
		nextAction: LOAN_ACTIONS.UPDATE_FORM_WITH_SCORING_AND_FINISH,
	},
];

export const LoanSimpleFormContainer = () => {
	const history = useHistory();
	const [login] = useLogin();
	const [utmSource, setutmSource] = useState('');
	const [formData, setformData] = useState({});
	const {
		executeAction,
		step,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
	} = useLoanFormContainerControl(
		DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_RECHAZO_KO,
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_SCORING_RECHAZO,
		DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_SOLICITUD_ENVIADA
	);

	const configAction: ActionButtonConfig[] = config.map((values) => {
		return {
			buttonBackName: values.buttonBackName,
			buttonNextName: values.buttonNextName,
			buttonBackClick: () => {
				executeAction(values.backAction, {
					...formData,
					flow: 'NORMAL',
					trafficSources: sessionStorage.getItem('trafficSources'),
				});
			},
			buttonNextClick: () => {
				executeAction(values.nextAction, {
					...formData,
					sourceUrl: 'credito-automotriz-2',
					source: utmSource !== '' ? 'SMART_CARGO' : '',
					flow: 'NORMAL',
					trafficSources: sessionStorage.getItem('trafficSources'),
				});
			},
		} as ActionButtonConfig;
	});

	useEffect(
		() => {
			setShowLoadingModal(true);
			login(
				() => {
					const urlSearchParams = new URLSearchParams(window.location.search);
					const utmSource = urlSearchParams.get('utm_source');
					if (utmSource) {
						setutmSource(utmSource);
					}
					console.log(utmSource);
					setShowLoadingModal(false);
				},
				() => history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`)
			);
		},
		//eslint-disable-next-line
		[]
	);

	const views: JSX.Element[] = [
		<LoanPersonalInfoSingleForm dataLayerKey={DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_INFO_PERSONAL} />,
		<LoanSimpleVehicleInfoForm
			dataLayerKey={DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_INFO_VEHICULO}
			isLoanSimple={true}
		/>,
	];

	return (
		<FormContext.Provider
			value={{
				setError: setEnableButton,
				setData: setformData,
				//storage: storageService,
			}}
		>
			<LoadingModal showLoadingModal={showLoadingModal} />

			<MultiFormContainer
				controlConfig={configAction}
				views={views}
				currentStep={step}
				isError={enableButton}
			/>
		</FormContext.Provider>
	);
};
